'use strict'
const Base = require('../base.edit')
const modal = new (require('../../helpers/modal'))
const forms = new (require('../../helpers/forms'))

module.exports = class menuWidget extends Base {

	onInit() {

		let button = document.createElement('button')
		button.className = 'formater'
		button.innerHTML = '<i class="material-icons">build</i>'
		// button.onclick = () => this.fromBlock()
		button.onclick = () => this.tree()
		this._elemButtons.appendChild(button)
		this.data = JSON.parse(JSON.stringify(this._data))
	}

	onDestroy() {
	}

	removeAllExpanded(arr) {
		if (!arr) { return }
		arr.forEach(item => {
			delete item.expanded
			if (item.subElements) {
				this.removeAllExpanded(item.subElements)
			}
		})
	}

	tree() {

		let div = document.createElement('div')
		div.className = 'reserve-space'
		this.menuwrapper = document.createElement('div')

		let foot = document.createElement('div')
		foot.className = 'popup-foot form-block'
		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Potvrdiť'
		button.onclick = () => {
			this.removeAllExpanded(this.data.subElements)
			this._data.subElements = this.data.subElements
			this._render({
				meta: {name: 'menu'},
				data: this._data,
			})
			modal.hide()
		}

		this.renderTree()
		div.appendChild(this.menuwrapper)
		foot.appendChild(forms.actions(button))
		modal.show('Menu', div, foot)

	}

	renderTree() {
		const menu = this.treeLevel(this.data)
		menu.className = 'menu-tree'
		this.menuwrapper.innerHTML = ''
		this.menuwrapper.appendChild(menu)
	}

	helperSpan(level, isAdd, expanded) {
		let helper = ''
		if (level > 0) {
			helper += '┃'.repeat(level - 1)
			helper += isAdd ? '┗' : '┣'
		}
		helper = '<span class="tree-helper">' + helper + '</span>'
		helper += isAdd ? '' :
			level > 1 ? '<i class="indicator material-icons">more_vert</i>':
				expanded ?
					'<i class="indicator material-icons">keyboard_arrow_up</i>' :
					'<i class="indicator material-icons">keyboard_arrow_down</i>'
		return helper
	}

	treeLevel(item, level) {
		if (!level) { level = 0 }
		let arr = item.subElements
		let ul = document.createElement('ul')
		if (item.expanded || level === 0) {
			if (arr) {
				arr.forEach(sub => {
					let li = document.createElement('li')
					let line = document.createElement('span')
					line.className = 'line'
					li.onclick = e => {
						e.stopPropagation()
						sub.expanded = !sub.expanded
						this.renderTree()
					}
					line.innerHTML = this.helperSpan(level, false, sub.expanded) + sub.name
					line.appendChild(this.editLink(sub))
					line.appendChild(this.movelinks(sub, arr))
					line.appendChild(this.rmLink(sub, arr))
					li.appendChild(line)
					li.appendChild(this.treeLevel(sub, level + 1))
					ul.appendChild(li)
				})
			}
			if (level < 3) {
				ul.appendChild(this.addSubItem(item, level))
			}
		}
		return ul
	}

	addSubItem(item, level) {
		let li = document.createElement('li')
		li.innerHTML = '<span class="line">' + this.helperSpan(level, true) +
			'<a>Pridať položku</a></span>'
		li.querySelector('a').onclick = e => {
			e.stopPropagation()
			if (!item.subElements) { item.subElements = [] }
			item.subElements.push({
				name: 'Nová položka',
				tags: [],
			})
			this.renderTree()
		}
		return li
	}

	editLink(item) {
		let a = document.createElement('button')
		a.innerHTML = '<i class="material-icons">edit</i>'
		a.onclick = e => {
			e.stopPropagation()
			this.editForm(item)
		}
		return a
	}

	rmLink(item, arr) {
		let a = document.createElement('button')
		a.className = 'text-danger'
		a.innerHTML = '<i class="material-icons">remove_circle_outline</i>'
		a.onclick = e => {
			e.stopPropagation()
			arr.splice(arr.indexOf(item), 1)
			this.renderTree()
		}
		return a
	}

	movelinks(item, arr) {

		let span = document.createElement('span')
		span.className = 'move'

		let up = document.createElement('button')
		up.innerHTML = '<i class="material-icons">arrow_upward</i>'
		up.disabled = arr.indexOf(item) === 0
		up.onclick = e => {
			e.stopPropagation()
			let i = arr.indexOf(item)
			arr.splice(i - 1, 0, arr.splice(i, 1)[0])
			this.renderTree()
		}

		let down = document.createElement('button')
		down.innerHTML = '<i class="material-icons">arrow_downward</i>'
		down.disabled = arr.indexOf(item) === arr.length - 1
		down.onclick = e => {
			e.stopPropagation()
			let i = arr.indexOf(item)
			arr.splice(i + 1, 0, arr.splice(i, 1)[0])
			this.renderTree()
		}

		span.appendChild(up)
		span.appendChild(down)
		return span
	}

	editForm(item) {

		let block = document.createElement('div')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'

		let text = document.createElement('input')
		text.value = item.name
		div.appendChild(forms.input('Názov', text))

		let tag = document.createElement('input')
		if (!item.tags) { item.tags = [] }
		tag.value = item.tags.join(',')
		div.appendChild(forms.input('Tagy', tag))

		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Potvrdiť'
		button.onclick = () => {
			item.name = text.value
			item.tags = tag.value.split(',')
			this.tree()
		}
		block.appendChild(forms.actions(button))

		let title = 'Menu položka'
		modal.show(title, block, null, this.tree.bind(this))
			.then(() => { tag.focus() })

	}

}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/menu-zosr/menu-zosr.edit.js
// module id = 477
// module chunks = 0